// AfishaMobile.js (обновленная версия)
import { Link } from "react-router-dom";
import { ImageLoader } from "../UI/ImageLoader";
import { BuyButton, DateBtn, InfoLine } from "./AfishaSlider";
import './Afisha.css';

export const AfishaMobile = ({ items }) => {
    return (
        <>
            {items.map((item) => {
                const isPremiere = item.showSchedules?.[0]?.nameInPremiera || false;
                const price = "от 12 000 ₽";

                return (
                    <div key={item.id} className="afisha-mobile-item">
                        <div className="afisha-card">
                            {isPremiere && (
                                <div className="premiere-badge">ПРЕМЬЕРА</div>
                            )}

                            <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                <div className='position-relative text-center overflow-hidden' style={{ padding: '1rem' }}>
                                    <ImageLoader
                                        src={`https://leningradcenter.ru/api/shows/afisha-img/${item.id}`}
                                        name={item.name}
                                        mHeight={'100vh'}
                                        className="card-image"
                                    />
                                </div>
                            </Link>

                            <div className="card-content">
                                <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                    <div className="afisha-title">{item.name}</div>
                                </Link>

                                <InfoLine
                                    ageCategory={item.ageCategory}
                                    duration={item.showSchedules?.[0]?.duration}
                                />

                                {item.buttonType === 0 && item.showSchedules?.length > 0 && (
                                    <div className="mt-2">
                                        <p className="afisha-date-label">Выберите дату</p>
                                        <div className="d-flex flex-wrap gap-2 mb-2">
                                            {item.showSchedules.slice(0, 5).map((date) => (
                                                <DateBtn key={date.id} schedule={date} />
                                            ))}
                                            {item.showSchedules.length > 5 && (
                                                <span className="afisha-more-dates">+{item.showSchedules.length - 5}</span>
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div className="d-flex align-items-center justify-content-between mt-2">
                                    <BuyButton item={item} />
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );
};